import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ConnectedRouter } from 'connected-react-router';
import { Provider } from 'react-redux';
import DateFnsUtils from '@date-io/date-fns';
import plLocale from 'date-fns/locale/pl';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import App from './App';
import Sentry from '../sentry';

export default class Root extends Component {
  render() {
    const { store, history } = this.props;
    return (
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <MuiPickersUtilsProvider utils={DateFnsUtils} locale={plLocale}>
            <Sentry.ErrorBoundary>
              <App />
            </Sentry.ErrorBoundary>
          </MuiPickersUtilsProvider>
        </ConnectedRouter>
      </Provider>
    );
  }
}

Root.propTypes = {
  store: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
};



// WEBPACK FOOTER //
// ./src/components/Root.js